import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
export const tableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    labelPosition: 'right',
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '640px',
    emptyText: '暂无数据',
    menu: false,
    column: [{
      label: '司机姓名',
      prop: 'driverName',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    {
      label: '手机号',
      prop: 'phone',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    {
      label: '前车车牌',
      prop: 'frontVehicleNumber',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      hide: true,
      align: 'center',
    },
    {
      label: '车辆类型',
      prop: 'vehicleTypeName',
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    {
      label: '预约园区',
      prop: 'appointmentParkName',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    {
      label: '预约到达时间',
      prop: 'estimatedArrivalTime',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      hide: true,
      align: 'center',
      formatter: function (row, value) {
        return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
      }
    },
    {
      label: '装/卸货',
      prop: 'operateTypeName',
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    {
      label: '客户',
      prop: 'custom',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    {
      label: '柜号',
      prop: 'cabinetNumber',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    {
      label: '申请时间',
      prop: 'createTime',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
      formatter: function (row, value) {
        return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
      }
    },
    {
      label: '状态',
      prop: 'appointmentStatusName',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    }
    ]
  }
}
